<template>
  <div class="title-container">
    <div class="title-content">
      <springText class="item-title" text="Bounty Squad Skill Bonuses"></springText>
    </div>
    <fadeInAnimation>
      <div class="sub-title">
        Click the character's avatar to view skill effects and equip a wearable skin.
      </div>
    </fadeInAnimation>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import springText from "@/views/components/springText";
import fadeInAnimation from "@/views/components/fadeInAnimation";

export default {
  mixins: [responsiveMixin],
  components: { springText, fadeInAnimation },
  data() {
    return {};
  },
  mounted() { },
  methods: {},
  watch: {

  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>